<p-toast [style]="{marginTop: '80px'}"></p-toast>
@if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
}

<div class="pl-4 pr-4" [formGroup]="form1">
  <p-fieldset styleClass="p-fluid " legend="Pricing Admin" [toggleable]="true" [collapsed]="true">
    <div class="p-formgrid grid">
      <div class="col-12">
        Global pricing admin for Rentals United.
      </div>
      <div class="flex justify-content-end mt-3">
        @if (formErrorMessage) {
          <small class="p-invalid"><br>{{formErrorMessage}}<br></small>
        }
        <br>
          <button pButton type="button" class="p-button-danger" label="Sync All Prices" (click)="onSyncAllPricesClick()"></button>
        </div>
      </div>
    </p-fieldset>

    <p-fieldset styleClass="p-fluid " legend="Select Property" [toggleable]="true" [collapsed]="false">
      <div class="p-formgrid grid">
        <div class="col-12">
          <b>Select Property</b>
        </div>

        <div class="p-field col-12 mt-3">
          <span class="p-float-label">
            <p-dropdown [options]="shortTermRentals" formControlName="shortTermRentalId" optionLabel="propertyCode" optionValue="shortTermRentalId" [filter]="true" filterBy="propertyCode" [showClear]="false"
              placeholder="Select Property">
            </p-dropdown>
            <label for="developmentId">Select Property</label>
            @for (validation of validationMessages.shortTermRentalId; track validation) {
              <span>
                @if (form1.get('shortTermRentalId').hasError(validation.type) && (form1.get('shortTermRentalId').dirty || form1.get('shortTermRentalId').touched)) {
                  <small id="developmentId-help" class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <p-divider class="col-12 mt-3 mb-3"></p-divider>

        <div class="col-12 mb-2">
          <b>View Rates</b>
        </div>

        <div class="p-field col-12 md:col-4 ">
          <span class="p-float-label">
            <p-calendar formControlName="startDate">
            </p-calendar>
            <label for="disabledays">From</label>
            @for (validation of validationMessages.startDate; track validation) {
              <span>
                @if (form1.get('startDate').hasError(validation.type) && (form1.get('startDate').dirty || form1.get('startDate').touched)) {
                  <small class="p-invalid">{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="p-field col-12 md:col-4">
          <span class="p-float-label">
            <p-calendar formControlName="endDate">
            </p-calendar>
            <label for="disabledays">To</label>
            @for (validation of validationMessages.endDate; track validation) {
              <span>
                @if (form1.get('endDate').hasError(validation.type) && (form1.get('endDate').dirty || form1.get('endDate').touched)) {
                  <small class="p-invalid">{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>


        <div class="p-field col-12">
          @if (formErrorMessage) {
            <small class="p-invalid"><br>{{formErrorMessage}}<br></small>
          }
          <button pButton class="p-button" type="button" style="width:200px;" label="View Rates" (click)="onShowPrices()"></button>
        </div>

        <p-divider class="col-12 mt-3 mb-3"></p-divider>

        <div class="col-12 mb-2">
          <b>Sync Rates</b>
        </div>

        @if (form1.value.shortTermRentalId) {
          <div class="mt-3">
            @if (formErrorMessage) {
              <small class="p-invalid"><br>{{formErrorMessage}}<br></small>
            }
            <br>
              <button pButton type="button" label="Sync Property" (click)="onFormSubmit()"></button>
              <div> <br><br>
                <a target="_blank" [routerLink]="['/logmans/short-term-rental', 'RU_PUSH_PRICE',this.form1.value.shortTermRentalId]"> View Logman for shortTermRentalId #{{this.form1.value.shortTermRentalId}}</a>
              </div>
            </div>
          }
        </div>
      </p-fieldset>
      <br>
        <span class="p-float-label">
          <textarea id="float-input" rows="5" style="width:100%;" pInputTextarea>{{ruResponse}}</textarea>
          <label for="float-input">Response</label>
        </span>
        <br>
          <br>

            <h2>LOS Pricing</h2>
            <p-table [value]="ruPrices">
              <ng-template pTemplate="header">
                <tr>
                  <th pSortableColumn="Date">Date <p-sortIcon field="Date"></p-sortIcon>
                </th>
                <th pSortableColumn="DefaultPrice">DefaultPrice <p-sortIcon field="DefaultPrice"></p-sortIcon>
              </th>
              <th pSortableColumn="Reservations">LOS Rates<p-sortIcon field="Reservations"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-prices>
          <tr>
            <td>{{prices.Date | date}} </td>
            <td>{{prices.DefaultPrice | currency : 'USD' : 'symbol' : '1.0-0' }} </td>
            <td>
              @for (dd of prices.FSPRows; track dd) {
                <span><b>{{dd.NrOfGuests}} Guests</b><br>
                @for (rr of dd.Prices; track rr) {
                  <span>{{rr.NrOfNights}}:
                    {{rr.Price|currency : 'USD' : 'symbol' : '1.0-0' }}&nbsp;&nbsp;
                    {{(rr.Price/rr.NrOfNights)| currency : 'USD' : 'symbol' : '1.0-0' }} / nt.
                    <br>
                    </span>
                  }
                </span>
              }
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>